import React from 'react';

import { useManageToolConfigs } from 'hooks/Tools/use-manage-tool-configs';
import { useToolGroups } from 'hooks/Tools/use-tool-groups';
import { ToolConfiguration } from 'pages/ManageSmartAssistant/Sections/ToolsSection/ToolConfiguration';
import { ToolsOverview } from 'pages/ManageSmartAssistant/Sections/ToolsSection/ToolsOverview';
import { ToolsSelector } from 'pages/ManageSmartAssistant/Sections/ToolsSection/ToolsSelector';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import { ROUTE_LINKS } from 'shared/constants/route-links';
import { SmartAssistant } from 'shared/interfaces/SmartAssistant';
import { StaticToolGroup } from 'shared/interfaces/tools/Tool';

interface ToolsSectionProps {
  smartAssistant: SmartAssistant;
}

export function ToolsSection({ smartAssistant }: ToolsSectionProps) {
  const navigate = useNavigate();

  const { unavailableToolGroups, unattachedToolGroups, attachedToolGroups } = useToolGroups({
    smartAssistantType: smartAssistant.type,
    existingToolConfigs: smartAssistant.toolConfigs ?? []
  });

  const { updateToolConfigs, deleteToolConfigs } = useManageToolConfigs({
    smartAssistantId: smartAssistant._id,
    existingToolConfigs: smartAssistant.toolConfigs ?? []
  });

  const basePath = `${ROUTE_LINKS.manageSmartAssistant}/${smartAssistant._id}/tools`;
  const handleAddTool = () => navigate(`${basePath}/selector`);
  const handleBackToOverview = () => navigate(basePath);
  const handleSelectToolGroup = (toolGroup: StaticToolGroup) => {
    navigate(`${basePath}/configure/${toolGroup.kind}`);
  };

  return (
    <Routes>
      <Route
        index
        element={
          <ToolsOverview
            attachedToolGroups={attachedToolGroups}
            deleteToolConfigs={deleteToolConfigs}
            onAddTool={handleAddTool}
          />
        }
      />
      <Route
        path="selector"
        element={
          <ToolsSelector
            unattachedToolGroups={unattachedToolGroups}
            attachedToolGroups={attachedToolGroups}
            unavailableToolGroups={unavailableToolGroups}
            onBack={handleBackToOverview}
            onSelectToolGroup={handleSelectToolGroup}
          />
        }
      />
      <Route
        path="configure/:toolGroupKind"
        element={<ToolConfiguration updateToolConfigs={updateToolConfigs} smartAssistant={smartAssistant} />}
      />
      <Route path="*" element={<Navigate to="" replace />} />
    </Routes>
  );
}
